'use strict';

module.exports = /* @ngInject */ function($q, $scope, $window, apiConfig, BeCustomerGroupAddressService, BeSupplierSettingsService) {
    
    $scope.addressType = {
        "UNITE": "UNITE",
        "CUSTOMER": "CUSTOMER"
    };
    $scope.isActive = {};
    $scope.customerGroupAddresses = [];
    $scope.uniteAddresses = [];
    $scope.selectedAddressType = "";
    $scope.uniteApiType = null;
    var popUpUrl = "";
    var customerGroupId = null;
    var supplierGroupId = null;
    

    $scope.init = init;

    /**
     * Initialize customer group id and supplier group id. Check if unite is active, if so retrieve the 
     * addresses for the customer from eproc api and the addresses already present in unite.
     * 
     * @param {string} customerGrpId
     * @param {string} supplierGrpId
     */
    function init(customerGrpId, supplierGrpId) {
        customerGroupId = customerGrpId;
        supplierGroupId = supplierGrpId;
        $q.all([isUniteActive(supplierGroupId)])
            .then(function(data) {
                if($scope.isActive.uniteActive) {
                    getCustomerGroupAddresses();
                    getUniteAddresses(supplierGroupId);
                    getUniteApiTypeForSupplier(supplierGroupId);
                }
            });
    }

    /**
     * Check if unite is active.
     * 
     * @param {string} supplierGroupId
     */
    function isUniteActive(supplierGroupId) {
        return BeSupplierSettingsService.isUniteActive.query({
            supplier_group_id: supplierGroupId
        }).$promise.then(
            //success
            function(data) {
                $scope.isActive = data;
            },
            function(error) {
                $scope.isActive = {uniteActive: false};
                console.log(error);
            }
        );
    }

    /**
     * Get unite api type for the given supplier group id.
     * 
     * @param {string} supplierGroupId 
     */
    function getUniteApiTypeForSupplier(supplierGroupId) {
        return BeSupplierSettingsService.getUniteApiType.query({
            supplier_group_id: supplierGroupId
        }).$promise.then(
            //success
            function(data) {
                $scope.uniteApiType = data.data;
            },
            function(error) {
                $scope.uniteApiType = null;
                console.log(error);
            }
        );
    }

    /**
     * Retrieve invoice addresses for the given customer group id.
     */
    function getCustomerGroupAddresses() {
        BeCustomerGroupAddressService.getAddressesByCustomerGroupId.query({customerCompanyId: customerGroupId}).$promise.then(
            //success
            function(data) {
                $scope.customerGroupAddresses = data;
            },
            //error
            function(err) {
                console.log(err.data.msg);
            }
        );
    }

    /**
     * Retireve addresses from unite for the given supplier group id.
     * 
     * @param {string} supplierGroupId 
     */
    function getUniteAddresses(supplierGroupId) {
        BeSupplierSettingsService.getUniteAddresses.query({
            supplier_group_id: supplierGroupId
        }).$promise.then(
            //success
            function(data) {
                $scope.uniteAddresses = data;
            },
            //error
            function(err) {
                console.log(err.data.msg);
            }
        );
    }

    /**
     * Set the selected address to the given address and construct the url for the popup.
     * 
     * @param {string} address - address id of the selected item
     */
    $scope.selectedItemChange = function(address) {
        $scope.selectedAddress = address;
        constructPopUpUrl();
    }

    /**
     * Clear the selected address and the search text. Otherwise the autocomplete bugs cause there is a random
     * search text appearing when changing between unite and customer address.
     * 
     * @param {string} addressType - type of the selected address
     */
    $scope.clearSelectedAddressAndSearchText = function(addressType) {
        $scope.selectedAddress = undefined;
        $scope.searchText = '';
        $scope.selectedAddressType = addressType;
    }

    /**
     * Construct url of the unite initialization popup.
     */
    function constructPopUpUrl() {
        popUpUrl = `${apiConfig.$get().apiUrl}/unite/init-customer?supplier=${supplierGroupId}&customer=${customerGroupId}&${$scope.selectedAddressType.toLowerCase()}_address=${$scope.selectedAddress}&access_token=${apiConfig.$get().accessToken}`;
    }

    /**
     * Open popup for unite initialization.
     */
    $scope.openPopupUnite = function() {
        $window.open(popUpUrl, 'popup', 'location=no,resizable=yes,scrollbars=yes,status=no,menubar=no,width=650,height=450');
    };

	/**
	 * Filters customerGroupAddresses based on a input string.
	 * @param searchText - string to filter accounts by
	 * @returns T[] - filtered array of accounts
	 */
	$scope.filterCustomerGroupAddresses = function (searchText) {
    	if(!searchText) {
    		return $scope.customerGroupAddresses.slice();
		} else {
    		return $scope.customerGroupAddresses.filter(function(address) {
    			return (address.companyName + ' ' + address.city + ' (' + address.taxId + ')').toLowerCase().indexOf(searchText.toLowerCase()) <= 0
			}).sort(function(a,b) {
				if(a.companyName < b.companyName ) {
					return 1;
				} else {
					return -1;
				}
			});
		}
    }
    
    /**
	 * Filters uniteAddresses based on a input string.
	 * @param searchText - string to filter accounts by
	 * @returns T[] - filtered array of accounts
	 */
    $scope.filterUniteAddresses = function(searchText) {
        if(!searchText) {
    		return $scope.uniteAddresses.slice();
		} else {
    		return $scope.uniteAddresses.filter(function(address) {
    			return (address.name + ' ' + address.address.locality + ' (' + address.vatId + ')').toLowerCase().indexOf(searchText.toLowerCase()) <= 0
			}).sort(function(a,b) {
				if(a.name < b.name ) {
					return 1;
				} else {
					return -1;
				}
			});
		}
    }

};
